import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';

import { connect } from 'react-redux';
import agent from '../agent'

import SchedLogo from '../assets/images/noun_Confirmed appointment.png';

import moment from 'moment'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from 'classnames';

import ReactJV from 'react-json-view'

import _ from 'lodash';

const renderField = ({ input, className, label, type, meta: { asyncValidating, touched, error, warning } }) => {
  return (
  	<div>
	    <input 
	      {...input} 
	      type={type}
	      className="is-invalid-input" 
	      placeholder={label} />
	    { 
	    	// <span className="form-error is-visible" id="uuid">{error}</span>
	    }
    </div>
  )
}

const RoomsList = ({ room, locations, onSelectedRoom, selectedRoom }) => {
	const location = locations.find(location => 
					location.id == room.location_id && location )
  const isSelectedRoom = selectedRoom.id == room.id
	return ( 
	<li className={classNames("room-item", {"active": isSelectedRoom })} onClick={() => onSelectedRoom(room, location) }>
		<div className="name">{room.name}</div>
		<div className="location">{location.address}</div>
	</li>
)}

const RoomCollection = (room, locations) => {
	const location = locations.find(location => 
					location.id == room.location_id && location)
	return (
		<option key={room.id} value={room.id}>{room.name + ' - ' + location.address}</option> 
	)
}

const Location = (room_id, rooms, locations) => {
	const room = rooms.find(room => 
					room.id == room_id && room)
	const location = locations.find(location => 
					location.id == room.location_id && location)
	return location
}

const DateCollection = (room, auditionEvents, project) => {
	const auditionEvent = auditionEvents.find(event =>
					event.room_id == room.id && event.project_id == project.id)
	console.log('datecollection', this.getAuditionEvents(auditionEvent))
	return (
		<p>asd</p>
	)
}

const ScheduleNavDateOption = props => {
	
		return (
			<li className={classNames("schedule-nav-date-option", { "active": props.isActiveDate, "ghosted": props.isBefore } )}
				onClick={() => !props.isBefore ? props.dateClicked(props.date) : "" }>
				<div className="week-name">{props.dateDisplay.week}</div>
				<div className="day">{props.dateDisplay.day}</div>
			</li>
		)
	

	return (
		<li className={classNames("schedule-nav-date-option", { "active": props.isActiveDate } )} 
			onClick={ () => props.dateClicked(props.date) }>
			<div className="week-name">{props.dateDisplay.week}</div>
			<div className="day">{props.dateDisplay.day}</div>
		</li>
	)

}

const EventSchedules = props => {
	const isdActive = props.selectedAuditionEvent.id == props.auditionEvent.id
	return (
		<div className={ classNames("time-range", {"active": isdActive}) }
		 onClick={() => props.onSelectAuditionEvent(props.auditionEvent) }>{props.timeRange}</div>
	)
} 

const validate = {
  required: value => !value && "This field is required",
}


class Scheduling extends Component {

	state = {
		displayCount: 9,
		date: new Date(),
		currentDate: moment.utc().startOf('day'),
		activeDate: this.currentDate,
		startDate: {},
		selectedDate: {},

		selectedRoom: {},
		selectedLocation: {},
		selectedAuditionEvent: null,
		auditionEvents: [],

		dropDownLocation: {},
		auditionDates: [],
		defaultRoom: {},
		sched_confirmed: false,
		selectedIndex: -1,
		available_rooms: [],
		selected_roles: [],
		completeSchedule: false,
    sched_preloaded: false
	}

	async componentDidMount() {

		const { rooms, locations, audition_events } = this.props.projectDetails
		const { activeDate, displayCount, available_rooms } = this.state

		// this.getRooms(this.props.projectDetails.project)
		// const auditionEvents = audition_events.filter( event => {
		// 	if (event.locked_flag) { return }

		// 	const localTime = this.localStartTime(event.start_time)
		// 	const eventDate = moment.tz(localTime, event.time_zone)

		// 	return event.room_id == rooms[0].id && moment(activeDate).isSame(eventDate, 'day') && event
		// })

    let inLocs = locations
    if (inLocs == null) {
      inLocs = await agent.Project.getLocations(this.props.projectDetails.id)
      inLocs = inLocs.locations
    }

    this.setState({locations: inLocs})

		let selRoom = window.localStorage.getItem('room')
		let selLocation = window.localStorage.getItem('location')

    try {
      selRoom = JSON.parse(selRoom);
      selLocation = JSON.parse(selLocation);
    } catch (error) {
      console.log('Error parsing')
      selRoom = null
      selLocation = null
    }

		if (selRoom || selLocation){
			this.setState({
				startDate: moment(activeDate).subtract(Math.floor(displayCount/2), 'days'),
				defaultAuditionEvent: [],
				selectedRoom: selRoom,
				selectedLocation: selLocation
			})
		}
		
		this.setState({
			startDate: moment(activeDate).subtract(Math.floor(displayCount/2), 'days'),
			selectedLocation: selLocation,
			defaultAuditionEvent: []
		})

    let room_info = await agent.Project.getRooms(this.props.projectDetails)

    if (room_info.meta != null) {
      const selEv = room_info.meta
      this.setState({ selectedRoom: selEv.rooms[0], 
                      selectedLocation: selEv.locations[0],
                      selectedAuditionEvent: selEv.audition_event_embed,
                      sched_confirmed: true, sched_preloaded: true
                    });
      this.setSchedule()
    }
	}

	getAuditionEvent = (room, auditionEvents, project) => {
		const auditionEvent = auditionEvents.find(event =>
					event.room_id == room.id && event.project_id == project.id)
  		this.props.getDateCollection(auditionEvent)
	}

	getRoomLocation = (room, locations) => {
  	const location = locations.find(location => 
					location.id == room.location_id && location)
  	return location.address
  	}

	onSelectedRoom = (room_id, rooms, locations) => {
		if (room_id != 0) {
			const room = rooms.find(room => 
						room.id == room_id && room)
			const location = locations.find(location => 
						location.id == room.location_id && location)
			window.localStorage.setItem('room', JSON.stringify(room))
			window.localStorage.setItem('location', JSON.stringify(location))
			console.log('onselectedroom', room, location)

      let project_id = null
      if (this.props.projectDetails.project != null) {
        project_id = this.props.projectDetails.project.id
      } else {
        project_id = this.props.projectDetails.id
      }

      this.props.getDateCollection({project_id: project_id, room_id: room_id})

			// this.getAuditionEvent(room, this.props.projectDetails.audition_events, this.props.projectDetails.project)
			this.setState({
				selectedRoom: room,
				selectedLocation: location
			})
		}
	}

	onSelectedTime = (event, index) => {
		this.props.setAuditionEventId(event)
	  	this.setState({
	  		selectedAuditionEvent: event,
	  		selectedIndex: index,
	  		completeSchedule: true
	  	})
	}

	setSchedule = () => {
		let selected_roles = window.localStorage.getItem('role_ids')
		let arr = selected_roles.split(',')
		let roles_arr = new Array()

		let exist_roles = this.props.roles.success ? this.props.roles.roles : this.props.roles;

		arr.map((role, index) => {
			roles_arr.push(exist_roles.find(r => r.id == role))
		})
		console.log('setSchedule', this.state.selectedLocation)
	  	this.setState({
	  		sched_confirmed: true,
	  		selected_roles: roles_arr
	  	})
	}

	reschedule = () => {
		this.setState({
	  		sched_confirmed: false,
        sched_preloaded: false
	  	})
	}

	onSelectedDate = (date) => {
		if (date != 0) {
			const projects = this.props.projectDetails
			const room = this.state.selectedRoom
			
      let auditionEvent = {}
      if (projects.project != null) {
			  auditionEvent = projects.audition_events.find(event =>
						event.room_id == room.id && event.project_id == projects.project.id)
        this.props.getAuditionEvents(auditionEvent, date)
      } else {
        this.props.getAuditionEvents({project_id: projects.id, room_id: room.id}, date)
      }
			
		}
	}

	// getRooms = (project) => {
	// 	this.props.getRooms(project)
	// }

	onChangeDate = (date) => {
		this.setState({ 
			activeDate: date,
			startDate: moment(date).subtract(Math.floor(this.state.displayCount/2), 'days')
		})
		this.toggleCalendar()
	}

	toggleCalendar = () => {
		this.setState({
			isCalendarOpen: !this.state.isCalendarOpen
		})
	}

	dateOptions = () => {
		const displayCount = this.state.displayCount
		const startDate = this.state.startDate
		const dateOptions = []

		for (let i = 0; i < displayCount; i++) {
			const newDateOption = moment(startDate).add(i, 'days')
			dateOptions.push(newDateOption)
		}
		return dateOptions
	}

	isActiveDate = (date) => {
		const activeDate = this.state.activeDate
    return moment(activeDate).isSame(date, 'day');
	}

  dateDisplay (date) {
  	return {
  		day: moment(date).format('D'),
  		week: moment(date).format('ddd')
  	}
  }

  localStartTime (startTime) {
  	const localTime = moment.utc(startTime).toDate()
  	return moment(localTime).format() // ISO 8601 format
  }

  timeRange2 (audition_event) {
  	const localTime = this.localStartTime(audition_event.start_time)
  	const startTime = moment.utc(localTime).format('h.mm a')
  	const timeCode = moment.tz(localTime, audition_event.time_zone).format('z')
  	if (parseInt(timeCode) >= 0)
  		return `${startTime} (GMT ${timeCode})`
  	return `${startTime} ${timeCode}`
  }

  dateConvert (date) {
  	return moment(date, 'YYYY-MM-DD').format('ddd DD MMM YYYY')
  }

  timeRange (audition_event) {
  	const localTime = this.localStartTime(audition_event.start_time)
  	const startTime = moment.utc(localTime).format('h:mm A')
  	const duration = parseInt(audition_event.duration_in_minutes)

  	let endTime = moment(localTime).add(duration, 'minute');
  	endTime = moment.utc(endTime).format('h:mm A')
  	const timeCode = moment.tz(localTime, audition_event.time_zone).format('z')

  	return `${startTime} - ${endTime} ${timeCode}`
  }

  previousDateClicked (startDate) {
  	console.log('previousDateClicked')
    this.setState({
    	startDate: moment(startDate).subtract(1, 'day')
    })
  }

  dateClicked = (date) => {
  	console.log('dateClicked', date)
  	this.getAuditionEvents(date)

  	this.setState({
  		activeDate: date,
  		startDate: moment(date).subtract(Math.floor(this.state.displayCount/2), 'days')
  	})
  }

  getAuditionEvents = (date, room) =>  {

  	const { projectDetails } = this.props

  	const project_id = projectDetails.project.id
		const room_id = room ? room.id : this.state.selectedRoom.id
		const current_date =  moment(date).format('YYYY-MM-DD')


		// const events = projectDetails.audition_events.filter( event => {
		// 	if (event.locked_flag) { return }
		// 	const localTime = this.localStartTime(event.start_time)
		// 	const eventDate = moment.tz(localTime, event.time_zone)

		// 	return event.room_id == room_id && moment(date).isSame(eventDate, 'day') && event
		// })

		// this.setState({
		// 	defaultAuditionEvent: events
		// })




  	// call api to get new auditionEvents
  	// const project_id = this.props.projectDetails.project.id
		// const room_id = room ? room.id : this.state.selectedRoom.id
		// const current_date =  moment(date).format('YYYY-MM-DD')
		// console.log('call api',{project_id, room_id, current_date})
    let that = this
		agent.Project.auditionEvents({project_id: project_id, room_id: room_id}, current_date).then(res => {
      that.setState({defaultAuditionEvent: res.audition_events})
    })
  }

  onSelectAuditionEvent = (event) => {
  	// const auditionEvent = agent.Project.auditionEventById(event.id).then( audition => {
  	// 	console.log('onSelectAuditionEvent', audition)
  	// })
  	// console.log(auditionEvent);
  	//console.log('selected_audition_eventsss', event)
  	this.props.setAuditionEventId(event)
  	this.setState({
  		selectedAuditionEvent: event
  	})
  }

  nextDateClicked (startDate) {
  	console.log('nextDateClicked')
    this.setState({
    	startDate: moment(startDate).add(1, 'day')
    })
  }

  async submit (values, dispatch, props) {
  	if (!values.audition_event_id && props.selected_audition_event != null) {
      if (typeof props.handleSave === "function") {
        props.handleSave(values)
      }
      return props.onSubmit(props.handleSubmit)
  	}

  	window.localStorage.removeItem('room')
  	window.localStorage.removeItem('location')

    const audition = await agent.Project.confirmReserve({
      eventId: values.audition_event_id,
      auditionId: values.audition_ids,
      override: true
    }).then(res => res)

    if (audition == null) {
      alert('Schedule is currently reserved. Choose a different schedule')
      return
    }

    if (typeof props.handleSave === "function") {
      props.handleSave(values)
    }

  	return props.onSubmit(props.handleSubmit)
  }

  

	render() {
	const { handleSubmit, previousPage, nextPage, dirty, pristine, submitting, projectDetails, auditionEvents, auditionDates, roles, available_rooms } = this.props
	const { rooms } = projectDetails

  let project = projectDetails

  if (project.project != null) {
    project = project.project
  }

	const { dateOptions, locations } = this.state
	//const audition_events  = auditionEvents ? auditionEvents : this.state.defaultAuditionEvent

	const audition_events = auditionEvents ? auditionEvents : this.state.auditionEvents
	// this.setState({
	// 	defaultRoom: rooms.length === 1 ? rooms[0] : {}
	// })
	// console.log('selectedAuditionEvent', this.state.selectedAuditionEvent)
	//const dates = this.generateRoomCollection(this.state.selectedRoom, projectDetails.audition_events, projectDetails.project)
	return (
		<form onSubmit={ handleSubmit(this.submit) } className="checking-availability-form" id="scheduling-form">

		{ 
			this.state.isCalendarOpen && 
				<DatePicker
	      selected={this.state.activeDate}
	      onChange={date => this.onChangeDate(date) }
	      onClickOutside={ this.toggleCalendar }
	      minDate={moment()}
	      inline
	      title="Select your prefered date"
	      withPortal />
    }

			<section className="section gray-bg">
				<div className="grid-x align-center">
					<div className="small-12 medium-10 large-8 cell">
						<div className="grid-x">
							<div className="cell">
								<div className="text-center">
									<h4 className="text-center">Good News, this project allows you to self schedule your audition time,</h4>
									<p>please select the location, date and time, that is suitable for you to attend.</p>
								</div>
							</div>
							<div className="cell">
								{
									!this.state.sched_confirmed ?
									<label className="label-size-top">Please select the room/location that suits you
										<Field 
									      name="room_collection" 
									      component="select"
									      onChange={(e) => this.onSelectedRoom(e.target.value, available_rooms, locations)}>
									      <option key={0} value={0}>Please select room/location</option>
									      {
									        available_rooms.map(room => (<option key={room.id} value={room.id}>{room.extended_name + ' - (' + room.state_name + ')'}</option>))
									      }
									    </Field>
								    </label> : <p></p>
							    }
							</div>
							<div className="cell">
								{
							    	!this.state.sched_confirmed ?
								    	this.state.selectedRoom ? 
								    		<p className="label-size-top-i">{this.state.selectedRoom.full_address}</p> : <p></p> : <p></p>
							    }
							</div>
							<div className="cell">
								{
							    	!this.state.sched_confirmed ?
								    	auditionDates.length ? 
											<label className="label-size">Please select the date/day that suits you
												<Field 
											      name="date_collection" 
											      component="select"
											      onChange={(e) => this.onSelectedDate(e.target.value)}>
											      <option key={0} value={0}>Please select date/day</option>
											      {
											        auditionDates.map((date, index) => (<option key={index + 1} value={date}>{this.dateConvert(date)}</option>))
											      }
											    </Field>
											</label>
										: <p></p> : <p></p>
								}
							</div>
							<div className="cell">
								{
									!this.state.sched_confirmed ?
										audition_events.length ?
											<div>
												<br />
												<label className="label-size-bottom">Please select from the available times below
													<div className="available-schedules">
														<Field name="audition_event_id" type="hidden" component={renderField} validate={[validate.required]}/>
														{
															<ul>
															{
																audition_events.map((audition_event, index) => 
																// auditionEvents && auditionEvents.audition_events.length &&
																// auditionEvents.audition_events.map( audition_event => 
																// <EventSchedules 
																// 	key={ audition_event.id }
																// 	onSelectAuditionEvent={ this.onSelectAuditionEvent }
																// 	selectedAuditionEvent={this.state.selectedAuditionEvent}
																// 	auditionEvent={ audition_event }
																// 	timeRange={ this.timeRange(audition_event) }/>
																	(<li key={index + 1} onClick={() => this.onSelectedTime(audition_event, index + 1)}>
																		<a className={classNames({'list-selection': index + 1 === this.state.selectedIndex})}>
																			{this.timeRange2(audition_event)}</a>
																	</li>)
																)
															}
															</ul>
														}

														{ 
															// auditionEvents && !audition_events.length && 
															!audition_events.length && 
															<div className="text-center">No Available Schedule for this date</div>
														}
													</div>
												</label>
											</div>
										: <p></p> : <p></p>
								}
							</div>
							<div className="cell">
								{
									this.state.sched_confirmed ?
									this.state.selectedAuditionEvent ?
										<div className="schedule-confirm">
											<img src={SchedLogo} width={'75px'} />
											<h4 className="schedule-confirm-header">Your Audition time is confirmed</h4>
											<div className="row-wrapper">
												<div className="row-1">
													<div className={classNames("column-1", "column-label")}>
														<p>Project: </p>
													</div>
													<div className={classNames("column-1", "overflow", "column-value")}>
														<p>{project.name}</p>
													</div>
                          <br/>
													<div className={classNames("column-1", "column-label")}>
														<p>Role/s: </p>
													</div>
													<div className={classNames("column-1", "address-overflow", "column-value")}>
														<ul>
														{	this.state.selected_roles.map((role, index) => 
																role != null && (<li key={index + 1}>{role.name}</li>)) }
														</ul>
													</div>
                          <br/>
													<div className={classNames("column-1", "column-label")}>
														<p>Where: </p>
													</div>
													<div className={classNames("column-1", "address-overflow", "column-value")}>
														<ul>
															<li>{this.state.selectedRoom.name}</li>
															<li>{this.state.selectedLocation.address}</li>
															<li>{this.state.selectedLocation.city}</li>
															<li>{this.state.selectedLocation.state + ' ' + this.state.selectedLocation.postal_code}</li>
															<li>{this.state.selectedLocation.country}</li>
														</ul>
													</div>
                          <br/>
													<div className={classNames("column-1", "column-label")}>
														<p>When: </p>
													</div>
													<div className={classNames("column-1", "overflow", "column-value")}>
														<p>{this.timeRange2(this.state.selectedAuditionEvent)}</p>
													</div>
												</div>
											</div>
											<br />
											<div className={classNames("row-wrapper", "row-below")}>
												<br />
												
												<div className="button-wrapper">
													<button className="button-resched" type="button" onClick={this.reschedule}>Reschedule</button>
												</div>
											</div>
										</div>
									: <p></p> : <p></p>
								}
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="section">
				<div className="grid-x align-center">
					<div className="small-12 cell text-center">
						{
			            previousPage &&
			            <button 
			              className="button primary previous" 
			              type="button" 
			              onClick={previousPage} >Previous</button>
	          }

	          {
	          	!this.state.sched_confirmed ?
	          		<button className="button primary next" type="button" disabled={!this.state.completeSchedule} onClick={this.setSchedule}>Next</button> : <div className='float-left'></div>
	          }

	          {
	          	this.state.sched_confirmed ?
		            nextPage 
		            ? <button className="button primary next" type="submit" disabled={pristine || submitting}>Next</button>
		            : <button className="button primary" 
										type="submit" 
										disabled={pristine || submitting}>
											{submitting ? 'Submitting you checking...' : 'Submit' }
									</button>
				: <p></p>
	          }
					</div>
				</div>
			</section>
		</form>
	)

	}
}

Scheduling = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Scheduling)


const mapStateToProps = state => ({
	auditionEvents: state.projects.auditionEvents ? state.projects.auditionEvents.audition_events : false,
	auditionDates: state.projects.auditionDates ? state.projects.auditionDates.result : [],
	//available_rooms: state.projects.available_rooms ? state.projects.available_rooms.rooms : [],
});

const mapDispatchToProps = dispatch => ({
	getAuditionEvents: (data, date) => 
		dispatch({ type: 'GET_AUDITION_EVENTS', payload: agent.Project.auditionEvents(data, date) }),
	// getRooms: (data) => 
	// 	dispatch({ type: 'GET_ROOMS', payload: agent.Project.getRooms(data) }),
	getDateCollection: data =>
		dispatch({ type: 'GET_AUDITION_DATES', payload: agent.Project.auditionDates(data) }),
	getAuditionEventById: id =>
		dispatch({ type: 'GET_AUDITION_BY_ID', payload: agent.Project.auditionEventById(id) }),
	setAuditionEventId: event =>
		dispatch(change('checkinWizard', 'audition_event_id', event.id)),
	reserveEvent: data =>
		dispatch({ type: 'RESERVE_AUDITION_EVENT', payload: agent.Project.reserve(data)})
});


export default connect(mapStateToProps, mapDispatchToProps)(Scheduling)


// WEBPACK FOOTER //
// ./src/components/Scheduling.js